"use client";

import { useEffect } from "react";
import { X } from "lucide-react";

export interface MapModalProps {
  isOpen: boolean;
  onClose: () => void;
  lat: number;
  lng: number;
  address: string;
}

export default function MapModal({ isOpen, onClose, lat, lng, address }: MapModalProps) {
  // Đóng popup bằng phím Esc
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Nhúng bản đồ không cần API key. Nếu có Google Maps Embed API key, thay bằng:
  // https://www.google.com/maps/embed/v1/place?key=YOUR_KEY&q=${lat},${lng}
  //const embedSrc = `https://www.google.com/maps?q=${lat},${lng}&z=16&output=embed`;
  //https://maps.nks.vn/@10.79,106.68,10
  const embedSrc = `https://www.google.com/maps?q=${lat},${lng}&z=16&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Bản đồ vị trí"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg overflow-hidden rounded-2xl bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          <p className="truncate pr-4 text-sm font-medium text-slate-800">NKS MAPS : {address}</p>
          <button
            onClick={onClose}
            aria-label="Đóng bản đồ"
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100"
          >
            <X size={16} />
          </button>
        </div>

        <iframe
          title={`Bản đồ vị trí ${address}`}
          src={embedSrc}
          width="100%"
          height="320"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        <div className="px-4 py-3">
          <a
            href={directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full rounded-lg bg-[#0077bb] py-2 text-center text-sm font-medium text-white transition hover:bg-[#00669e]"
          >
            Chỉ đường trên Google Maps
          </a>
        </div>
      </div>
    </div>
  );
}
